import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.svg``;

const IconDebank: React.FC = () => {
	return (
		<Wrapper width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="60" height="60" rx="10" fill="#202251" />
			<path
				opacity="0.8"
				d="M42.4048 36.3495C42.4048 41.2346 38.3853 45.1947 33.4269 45.1947H16.4688V39.2979H33.4269C35.0797 39.2979 36.4195 37.9779 36.4195 36.3495C36.4195 34.7212 35.0797 33.4011 33.4269 33.4011H27.4417V27.5043H33.4269C35.0797 27.5043 36.4195 26.1843 36.4195 24.5559C36.4195 22.9276 35.0797 21.6075 33.4269 21.6075H16.4688V15.7108H33.4269C38.3853 15.7108 42.4048 19.6709 42.4048 24.5559C42.4048 26.8213 41.5404 28.8878 40.1187 30.4527C41.5404 32.0176 42.4048 34.0841 42.4048 36.3495Z"
				fill="white"
			/>
			<path
				opacity="0.12"
				d="M16.4688 39.2979H31.0341C27.9402 42.8786 23.0144 45.1947 17.4663 45.1947C17.1314 45.1947 16.7988 45.1863 16.4688 45.1696V39.2979ZM34.0852 33.4011H28.4392V27.5043H34.0852C34.3077 28.457 34.4245 29.443 34.4245 30.4527C34.4245 31.4624 34.3077 32.4485 34.0852 33.4011ZM31.0341 21.6075H16.4688V15.7358C16.7988 15.7192 17.1314 15.7108 17.4663 15.7108C23.0144 15.7108 27.9402 18.0269 31.0341 21.6075Z"
				fill="black"
			/>
			<path
				d="M16.4688 15.7108C24.7326 15.7108 31.4318 22.311 31.4318 30.4527C31.4318 38.5945 24.7326 45.1947 16.4688 45.1947V39.2979C21.4271 39.2979 25.4466 35.3378 25.4466 30.4527C25.4466 25.5677 21.4271 21.6075 16.4688 21.6075V15.7108Z"
				fill="white"
			/>
		</Wrapper>
	);
};

export default IconDebank;
